export default "__VITE_ASSET__CO4do8dh__"